<template>
  <v-form v-model="valid" ref="mainForm">
    <CarteIdentification :identification="identification" class="mb-6" />
    <DatePickerLive
      code="date_changement"
      v-model="sasInscriptionTableau.dateDuChangementSouhaite"
      :live="{ endpoint: 'sas-inscription-tableau', cle: 7706, fileId: sasInscriptionTableau.id }"
      :minValue="serverDateBefore22h00()"
      :maxValue="convertStrDateToString(sas.dateChangementMax)"
      @eudo-updated="updatePanier"
    />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CarteIdentification from "@/components/form_parts/CarteIdentification.vue"
import { mapActions } from "vuex"

export default {
  components: { CarteIdentification },
  mixins: [CataloguesHelpers, DatesHelpers, StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    identification() {
      return this.sas.identification
    },
    sasInscriptionTableau() {
      return this.sas.sasInscriptionTableau
    }
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    updatePanier() {
      this.fetchPanier({ endpoint: "demande-changement-categorie-membre", sasId: this.sas.id })
    }
  }
}
</script>

<style></style>
